import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { TableProvider, useTable } from "@/lib/store";
import { Shell } from "@/components/Shell";
import Gate from "@/pages/Gate";
import Home from "@/pages/Home";
import Chapters from "@/pages/Chapters";
import DateFinder from "@/pages/DateFinder";
import Drive from "@/pages/Drive";
import HistoryPage from "@/pages/History";
import ChapterDetail from "@/pages/ChapterDetail";
import Goals from "@/pages/Goals";
import Ledger from "@/pages/Ledger";
import Feed from "@/pages/Feed";
import Members from "@/pages/Members";
import MemberDetail from "@/pages/MemberDetail";
import Library from "@/pages/Library";
import ParkingLot from "@/pages/ParkingLot";
import Fines from "@/pages/Fines";
import Baseline from "@/pages/Baseline";
import Admin from "@/pages/Admin";
import Charter from "@/pages/Charter";
import Actions from "@/pages/Actions";
import Cup from "@/pages/Cup";
import CupCriterion from "@/pages/CupCriterion";

const Booting = () => (
  <div className="min-h-screen flex items-center justify-center">
    <span className="text-[14px] font-medium" style={{ color: "#64748b" }}>Setting the table…</span>
  </div>
);

const Inside = () => {
  const { me, booting } = useTable();
  if (booting) return <Booting />;
  if (!me) return <Gate />;
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/charter" element={<Charter />} />
        <Route path="/actions" element={<Actions />} />
        <Route path="/cup" element={<Cup />} />
        <Route path="/cup/:id" element={<CupCriterion />} />
        <Route path="/chapters" element={<Chapters />} />
        <Route path="/chapters/:id" element={<ChapterDetail />} />
        <Route path="/date-finder" element={<DateFinder />} />
        <Route path="/drive" element={<Drive />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/ledger" element={<Ledger />} />
        <Route path="/feed" element={<Feed />} />
        <Route path="/members" element={<Members />} />
        <Route path="/members/:id" element={<MemberDetail />} />
        <Route path="/library" element={<Library />} />
        <Route path="/parking" element={<ParkingLot />} />
        <Route path="/fines" element={<Fines />} />
        <Route path="/baseline" element={<Baseline />} />
        <Route path="/admin" element={me.isAdmin ? <Admin /> : <Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <TableProvider>
        <Toaster position="top-center" />
        <Routes>
          <Route path="*" element={<Inside />} />
        </Routes>
      </TableProvider>
    </BrowserRouter>
  );
}
